module.exports = __webpack_public_path__ + "img/accept-left-circle2.ac98d82a.svg";